import { ref } from 'vue';

export interface NotificationAction {
  text: string;
  action: () => void;
}

export interface Notification {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration: number;
  show: boolean;
  actions?: NotificationAction[];
}

const notifications = ref<Notification[]>([]);

export const useNotifications = () => {
  const showNotification = (
    message: string, 
    type: Notification['type'] = 'info',
    duration: number = 5000,
    actions?: NotificationAction[]
  ) => {
    const id = Date.now().toString();
    const notification: Notification = {
      id,
      message,
      type,
      duration,
      show: true,
      actions,
    };

    notifications.value.push(notification);

    // Auto remove notification
    setTimeout(() => {
      removeNotification(id);
    }, duration);
  };

  const removeNotification = (id: string) => {
    const index = notifications.value.findIndex(n => n.id === id);
    if (index > -1) {
      notifications.value[index].show = false;
      setTimeout(() => {
        notifications.value.splice(index, 1);
      }, 300);
    }
  };

  const clearNotifications = () => {
    notifications.value = [];
  };

  return {
    notifications: notifications,
    showNotification,
    removeNotification,
    clearNotifications,
  };
};
